import { Typography } from '@amway/react-components';
import { mdiKeyboardBackspace } from '@mdi/js';
import { useEffect } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import IconButton from '../../../components/ui/icon-btn';
import TranslationsToolFormComponent from '../translations-form';
import { TranslationFormData } from '../../../resources/translations/translations-model';
import useTranslationList from '../../../resources/translations/translations-hook';

type Props = {
    onBackClick: VoidFunction;
    user: string | undefined
};

export default function TranslationToolAddComponent({ onBackClick, user }: Props) {
    const { addTranslation, addTranslationStatus } = useTranslationList();

    const handleCreate = (data: TranslationFormData) => {
        addTranslation({
            ...data,
            createdBy: user!
        });
    };

    useEffect(() => {
        if (addTranslationStatus.success) {
            onBackClick();
        }
    }, [addTranslationStatus.success, onBackClick]);

    return (
        <Card className="translation-tool-add">
            <Card.Body>
                <Row>
                    <Col>
                        <IconButton mdiIconPath={mdiKeyboardBackspace} onClick={onBackClick} title="Back" size="27px">
                            Back to Translations List
                        </IconButton>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Typography variant="heading">Add New Translation</Typography>
                        <Typography weight="bold" color="text-gray" className="mt-3">
                            Fill in the fields below to create a new translation.
                        </Typography>
                    </Col>
                </Row>
                <Row>
                    <TranslationsToolFormComponent
                        submitLabel="CREATE"
                        onSubmit={handleCreate} />
                </Row>
            </Card.Body>
        </Card>
    );
}
